import { useRequest } from '../useRequest';
// api
import api from 'utils/api';

/**
 * Artist identities the logged-in user may act for (`GET /artist-identities`):
 * the artists of every invited deal the user owns or is a member of. Drives
 * Publishing. Not the KYC/payout profiles (`useArtistProfiles`), which only a
 * deal owner has.
 */
export interface IArtistIdentity {
  spotifyId: string | null;
  youtubeId: string | null;
  artistName: string | null;
  artistImage: string | null;
  role: 'owner' | 'member';
}

export const useArtistIdentities = (skip = false) => {
  const { data, error, mutate } = useRequest<IArtistIdentity[]>(
    skip ? null : '/artist-identities',
    () => api.artistIdentities.list()
  );

  return {
    identities: data,
    isLoading: !skip && !data && !error,
    error,
    mutate,
  };
};
